import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

export async function markAnnulledPdf(bytes) {
  const pdf = await PDFDocument.load(bytes);
  if (!pdf.getPageCount()) throw new Error('Text_FormDI_Annul_Error');
  const font = await pdf.embedFont(StandardFonts.HelveticaBold);
  for (const page of pdf.getPages()) {
    const size = Math.min(64, page.getWidth() / 8);
    const width = font.widthOfTextAtSize('ANULADO', size);
    page.drawText('ANULADO', {
      x: (page.getWidth() - width) / 2,
      y: page.getHeight() / 2,
      size, font, color: rgb(0.8, 0, 0), opacity: 0.4,
    });
  }
  return pdf.save();
}

export async function createAnnulledPdf(blob) {
  const bytes = await markAnnulledPdf(await blob.arrayBuffer());
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(String(reader.result || '').split(',')[1] || '');
    reader.onerror = reject;
    reader.readAsDataURL(new Blob([bytes], { type: 'application/pdf' }));
  });
}
